/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ServicePanelType {
    TAXI = 'Taxi',
    MARKET = 'Market',
    WALLET = 'Wallet',
    WADE_SPINNER = 'WadeSpinner',
}
